import { SplashScene } from './SplashScene';
import { GameManager } from './../../GameManager';
import { GameOverLayer } from './../maze-scene/GameOverLayer';
import { Button } from './../../utils/Utils';
import { GameVars } from './../../GameVars';
import { GameConstants } from './../../GameConstants';

export class SelectLanguageLayer extends Phaser.GameObjects.Container {

    private flagSelected: Phaser.GameObjects.Image;

    private dropContainer: Phaser.GameObjects.Container;
    private dropLanguage: Phaser.GameObjects.Image;
    private flags: Phaser.GameObjects.Image[];

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH;
        this.y = GameConstants.GAME_HEIGHT;

        this.scaleY = GameVars.scaleY;

        let btn = new Button(this.scene, -50, -40, "texture_atlas_1", "btn_language");
        btn.onDown(this.onSelectLanguageDown, this);
        this.add(btn);

        this.flagSelected = new Phaser.GameObjects.Image(this.scene, -50, -40, "texture_atlas_1", "language_" + GameVars.gameData.language);
        this.add(this.flagSelected);

        this.dropContainer = new Phaser.GameObjects.Container(this.scene, -50, -70);
        this.dropContainer.scaleY = 0;
        this.add(this.dropContainer);

        this.dropLanguage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_drop_language");
        this.dropLanguage.setOrigin(.5, 1);
        this.dropContainer.add(this.dropLanguage);

        this.flags = [];

        let count = 0;

        for (let i = 0; i < GameConstants.LANGUAGES.length; i++) {
            if (GameConstants.LANGUAGES[i] !== GameVars.gameData.language) {

                let flag = new Phaser.GameObjects.Image(this.scene, 0, -265 + 45 * count, "texture_atlas_1", "language_" + GameConstants.LANGUAGES[i]);
                flag.name = GameConstants.LANGUAGES[i];
                flag.setInteractive();
                flag.on("pointerdown", () => {
                    this.onFlagDown(flag);
                }, this);
                this.dropContainer.add(flag);
                this.flags.push(flag);

                count++;
            }
        }
    }

    private onFlagDown(img: Phaser.GameObjects.Image): void {
        
        GameVars.gameData.language = img.name;
        GameManager.writeGameData();

        this.flagSelected.setFrame("language_" + GameVars.gameData.language);

        let count = 0;

        for (let i = 0; i < GameConstants.LANGUAGES.length; i++) {
            if (GameConstants.LANGUAGES[i] !== GameVars.gameData.language) {
                this.flags[count].setFrame("language_" + GameConstants.LANGUAGES[i]);
                this.flags[count].name = GameConstants.LANGUAGES[i];

                count++;
            }
        }

        SplashScene.currentInstance.languageChanged();

        this.onSelectLanguageDown();
    }

    private onSelectLanguageDown(): void {

        if (this.dropContainer.scaleY !== 1) {
            this.scene.tweens.add({
                targets: this.dropContainer,
                scaleY: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 100
            });
        } else {
            this.scene.tweens.add({
                targets: this.dropContainer,
                scaleY: 0,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 100
            });
        }
    }
}
